import React, { useEffect, useState } from 'react';
import { FaultDefinitionProps } from './FaultDefinition.props';
import { TableCell } from '@mui/material';
import { TextField } from '../../atoms/TextField';
import { Checkbox, CheckboxColorProps } from '../../atoms/Checkbox';
import { convertToArray } from '../../../utils/common';
import { ANY_KEYWORD } from '../../../constants/common';
import { useGetActionTypes } from '../../../queries/service-query';
import { ActionType } from '../../../@types/service.type';
import { StyledTableRow } from './FaultDefinition.styles';
import { MultiSelectCheckmarksMenu } from '../../atoms/MultiSelectCheckmarksMenu';

export const FaultDefinition: React.FC<FaultDefinitionProps> = ({
  faultDefinitaionData,
  isParentFaultDefinition = false,
  testDataId = '',
  onChange
}) => {
  const [faultActionTypes, setFaultActionTypes] = useState<{ value: string; label: string }[]>([]);

  const getActionTypes = useGetActionTypes();

  useEffect(() => {
    if (getActionTypes.data && Array.isArray(getActionTypes.data)) {
      setFaultActionTypes(getActionTypes.data.map((actionType: ActionType) => ({
        value: actionType.code,
        label: actionType.name
      })));
    }
  }, [getActionTypes.data]);

  // Handle multi-select changes
  const handleMultiSelectChange = (actionTypes: string) => {
    const selectedValues = convertToArray(actionTypes);
    
    // Handle "Any" selection logic - if "Any" is selected, clear other selections
    let finalSelectedValues = selectedValues;
    if (selectedValues.some((actionType: string) => actionType === ANY_KEYWORD)) {
      finalSelectedValues = [ANY_KEYWORD];
    }

    // Update the parent data with the selected action types
    onChange({
      ...faultDefinitaionData,
      actionTypes: finalSelectedValues
    });
  };
  return (
    <StyledTableRow isParent={isParentFaultDefinition}>
      <TableCell sx={{ pl: isParentFaultDefinition ? 0 : 6 }}>
        <TextField
          value={faultDefinitaionData.name}
          fullWidth={true}
          inputProps={{
            'data-testid': `${testDataId}-name`
          }}
          onChange={(text) => onChange({
            ...faultDefinitaionData,
            name: text
          })}
        />
      </TableCell>
      <TableCell>
        <TextField
          value={faultDefinitaionData.customerId}
          fullWidth={true}
          inputProps={{
            'data-testid': `${testDataId}-customerId`
          }}
          onChange={(text) => onChange({
            ...faultDefinitaionData,
            customerId: text
          })}
        />
      </TableCell>
      <TableCell>
        <TextField
          value={faultDefinitaionData.customerId2}
          fullWidth={true}
          inputProps={{
            'data-testid': `${testDataId}-customerId2`
          }}
          onChange={(text) => onChange({
            ...faultDefinitaionData,
            customerId2: text
          })}
        />
      </TableCell>
      <TableCell>
        {isParentFaultDefinition ? (
          <MultiSelectCheckmarksMenu
            id={`${testDataId}-action-type-options`}
            selectedValue={faultDefinitaionData.actionTypes || []}
            onChange={handleMultiSelectChange}
            items={(() => {
              const defaultActionType = [{ value: 'any', label: 'Any', disabled: false }];
              const actionTypeList = faultActionTypes.map(actionType => ({
                value: actionType.value,
                label: actionType.label,
                disabled: false
              }));
              return defaultActionType.concat(actionTypeList);
            })()}
          />
        ) : null}
      </TableCell>
      <TableCell align="center">
        <Checkbox
          color={CheckboxColorProps.Primary}
          checked={faultDefinitaionData.isReported}
          testDataId={`${testDataId}-reported`}
          onChange={(event) => onChange({
            ...faultDefinitaionData,
            isReported: event.target.checked
          })}
        />
      </TableCell>
      <TableCell align="center">
        <Checkbox
          color={CheckboxColorProps.Primary}
          checked={faultDefinitaionData.isObserved}
          testDataId={`${testDataId}-observed`}
          onChange={(event) => onChange({
            ...faultDefinitaionData,
            isObserved: event.target.checked
          })}
        />
      </TableCell>
      <TableCell align="center">
        <Checkbox
          color={CheckboxColorProps.Primary}
          checked={faultDefinitaionData.isActive}
          testDataId={`${testDataId}-active`}
          onChange={(event) => onChange({
            ...faultDefinitaionData,
            isActive: event.target.checked
          })}
        />
      </TableCell>
    </StyledTableRow>
  );
};